import type { TableColumnsType } from "antd";
import { Table } from "antd";
import "moment/locale/ar";

import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getDonationsDetails,
  getPaymentDetails,
  getSponsorPaymentReport,
} from "../../../apis/actions/sponsor.actions";
import { getParticipantDonations } from "../../../apis/actions/participants.actions";
import { AppDispatch, RootState } from "../../../apis/store";
import DotsLoader from "../../../biblio/Loader/DotsLoader";
import Selects from "../../../biblio/Selects/Selects";
import PaginationComponent from "../../../biblio/Pagination/PaginationComponent";
import {
  getDateRange,
  scroll,
} from "../../../components/utils/utils";

import { PrinterOutlined } from "@ant-design/icons";
import PdfPreview from "../../../biblio/Modal/PdfPreview";
import CustomConfigProvider from "../ProfileHeader";
import ParticipantMediaCollapse from "../ParticipantMediaCollapse";
interface Props {
  type: string;
  // Participant roles get their donations from participant/donations
  isParticipant?: boolean;
}

const DonationPayment = ({ type, isParticipant = false }: Props) => {
  const dispatch = useDispatch<AppDispatch>();

  const currentRef = useRef<HTMLDivElement>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [url, setUrl] = useState<string>("");

  const [state, setState] = useState({
    year: "",
    month: "",
  });

  const [participantId, setParticipantId] = useState<number | null>(null);

  const sponsorState = useSelector((state: RootState) => state?.sponsor);
  const participantState = useSelector(
    (state: RootState) => state?.participants
  );
  const { payments, TotalPayments } = sponsorState;
  const isParticipantDonations = isParticipant && type === "donation";
  const loading = isParticipantDonations
    ? participantState.loading
    : sponsorState.loading;
  const donations = isParticipantDonations
    ? participantState.donations
    : sponsorState.donations;
  const TotalDonations = isParticipantDonations
    ? participantState.donationsTotalPages
    : sponsorState.TotalDonations;
  const otpId = useSelector((state: RootState) => state?.recipient?.OtpId);
    useEffect(() => {
      setCurrentPage(1);
    }, [state, participantId]);
  useEffect(() => {
    const fetchData = async () => {
      const { date_from, date_to } = getDateRange(state.year, state.month);

      if (type === "payment") {
        await dispatch(
          getPaymentDetails({
            sponsor_id: otpId,
            limit: itemPerPage,
            page: currentPage,
            date_from: date_from,
            date_to: date_to,
          })
        );
      } else if (isParticipant) {
        await dispatch(
          getParticipantDonations({
            participant_id: participantId,
            limit: itemPerPage,
            page: currentPage,
            date_from: date_from,
            date_to: date_to,
          })
        );
      } else {
        await dispatch(
          getDonationsDetails({
            sponsor_id: otpId,
            limit: itemPerPage,
            page: currentPage,
            date_from: date_from,
            date_to: date_to,
          })
        );
      }
    };
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, type, currentPage, state, participantId]);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };

  useEffect(() => {
    if (type === "payment" && payments) {
      setData(payments);
      setCurrentData(payments);
    } else if (type === "donation" && donations) {
      setData(donations);
      setCurrentData(donations);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, payments, donations]);

  const toPrint = async (id: number) => {
    const report = (await dispatch(getSponsorPaymentReport(id))) as any;
    const file =
      report?.payload?.data != null
        ? new Blob([report?.payload?.data], { type: "application/pdf" })
        : null;

    setUrl(file ? URL.createObjectURL(file) : "");
  };
  const columns1: TableColumnsType<any> = [
    {
      title: "رقم السند",
      dataIndex: "name",
      render: (text: string) => (
        <b className="takaful--text-color-blue">
          <span>{text}</span>
        </b>
      ),
    },
    {
      title: "تاريخ السند ",
      dataIndex: "date",
      render: (text: string) => (
        <span className="takaful--font-tajwal">{text}</span>
      ),
    },
    {
      title: "طريقة السداد",
      dataIndex: "payment_method_id",
    },

    {
      title: "المبلغ",
      dataIndex: "amount",
    },
    {
      title: "",
      dataIndex: "id",
      render: (id: number) => (
        <PrinterOutlined
          onClick={() => toPrint(id)}
          className="takaful--print-icon"
        />
      ),
    },
  ];
  const columns: TableColumnsType<any> = [
    {
      title: "رقم السند",
      dataIndex: "name",
      render: (text: string) => (
        <b className="takaful--text-color-blue">
          <span>{text}</span>
        </b>
      ),
    },
    {
      title: "تاريخ السند ",
      dataIndex: "date",
      render: (text: string) => (
        <span className="takaful--font-tajwal">{text}</span>
      ),
    },
    {
      title: "طريقة السداد",
      dataIndex: "payment_method_id",
    },
    {
      title: "نوع التبرع",
      dataIndex: "request_type_id",
    },
    {
      title: "المبلغ",
      dataIndex: "amount",
    },
    {
      title: "",
      dataIndex: "id",
      render: (id: number) => (
        <PrinterOutlined
          onClick={() => toPrint(id)}
          className="takaful--print-icon"
        />
      ),
    },
  ];

  const itemPerPage = 8;

  useEffect(() => {
    setCurrentPage(1);
  }, [state]);

  useEffect(() => {
    setState({ month: "", year: "" });
    setParticipantId(null);
  }, [type]);
  return (
    <div className="takaful--sponsor-donation-payment">
      <CustomConfigProvider
        withdateFilter={true}
        filterState={state}
        setState={(values) => setState(values)}
        title={type === "payment" ? "تفاصيل دفعات الكفالة" : "تفاصيل التبرعات"}
      >
        {isParticipantDonations && (
          <Selects
            options={participantState.donationParticipants}
            selectPlaceholder="المساهم"
            onChange={(value: any) => setParticipantId(value?.value ?? null)}
            allowClear={true}
            className="takaful--service-select takaful--request-select"
            popupClassName="takaful--service-select-dropdown"
          />
        )}
      </CustomConfigProvider>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ minHeight: "20vh" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : (
        <>
          {isParticipantDonations ? (
            !currentData?.length ? (
              <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
                {state.year !== "" || participantId !== null
                  ? "لا يوجد تبرعات تتوافق مع البحث الذي قمت به"
                  : "لا يوجد تبرعات"}
              </p>
            ) : (
              <div ref={currentRef}>
                <ParticipantMediaCollapse
                  groups={currentData}
                  loading={loading}
                  renderContent={(group) => (
                    <Table<any>
                      style={{ direction: "rtl" }}
                      columns={columns}
                      dataSource={group.donations}
                      rowKey="id"
                      className="takaful--sponsor-table"
                      scroll={{ x: "max-content" }}
                      pagination={false}
                      locale={{ emptyText: "لا يوجد تبرعات " }}
                    />
                  )}
                />
              </div>
            )
          ) : (
            <Table<any>
              style={{ direction: "rtl" }}
              columns={type === "payment" ? columns1 : columns}
              dataSource={currentData}
              className="takaful--sponsor-table"
              scroll={{ x: "max-content" }}
              pagination={false}
              locale={{
                emptyText:
                  type === "payment" ? "لا يوجد دفعات" : "لا يوجد تبرعات ",
              }}
            />
          )}
          {data &&
            Math.ceil(TotalPayments * itemPerPage) > itemPerPage &&
            type === "payment" && (
              <PaginationComponent
                active={currentPage}
                total={Math.ceil(TotalPayments * itemPerPage)}
                itemPerPage={itemPerPage}
                scroll={() => scroll(currentRef)}
                setActive={(nb) => updateActive(nb)}
              />
            )}
          {data &&
            Math.ceil(TotalDonations * itemPerPage) > itemPerPage &&
            type !== "payment" && (
              <PaginationComponent
                active={currentPage}
                total={Math.ceil(TotalDonations * itemPerPage)}
                itemPerPage={itemPerPage}
                scroll={() => scroll(currentRef)}
                setActive={(nb) => updateActive(nb)}
              />
            )}
        </>
      )}

      <PdfPreview
        open={url !== ""}
        onClose={() => setUrl("")}
        url={url}
        isBlob={true}
        className="takaful--pdf-preview-modal"
      />
    </div>
  );
};

export default DonationPayment;
